// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
}
.login_container .tvs_logo {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 40px 0px;
}
.login_container .loginfirstpara {
  width: 50% !important;
  height: 100%;
}
.login_container .login_main {
  background: #ffffff;
  box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  width: 100%;
  height: 100%;
  margin-bottom: 2rem;
}
.login_container .login_main .login_tvsadminfirst {
  margin: 0rem 0rem;
  padding: 0rem 0rem;
  display: flex;
  gap: 0.4rem;
  align-items: center;
  justify-content: center;
}
.login_container .login_main .login_tvsadminfirst > img {
  margin: 1rem 0rem;
}
.login_container .login_main .login_thirdpara {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
.login_container .login_main .loginthirdpara {
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.login_container .login_main .language_input_box {
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.login_container .login_main .language_input_wrapper {
  position: relative;
  width: 85%;
}
.login_container .login_main .login_textsecond {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.28px;
  color: #9497a0;
  display: flex;
  justify-content: center;
  margin: 1rem 0rem;
}
.login_container .login_main .test {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_container .login_main .recaptchaContainer {
  margin: 1rem;
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.login_container .login_main .Login_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 35px;
  letter-spacing: -0.28px;
  color: #10132e;
}
.login_container .login_main .login_button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_container .login_main .login_button > img {
  width: 75%;
  object-fit: cover;
  object-position: bottom;
}
.login_container .login_main .login-nowslogin-nows {
  margin: 0rem 1rem;
}
.login_container .login_main .login-now-buttons {
  width: 66%;
  height: 60px;
  border-radius: 5px;
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}
.login_container .login_main .loginnows {
  margin: 0rem 1rem;
  font-size: 25px;
}
.login_container .login_main .logininput {
  width: 700px;
  height: 605px;
}
.login_container .login_main .Forget_text {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.28px;
  text-decoration-line: underline;
  color: #0c3688;
  margin: 1rem 0rem;
}
.login_container .login_main .Forgettextdiv {
  margin: 1rem 0rem 0rem 0rem;
  padding: 1rem 0rem 1rem 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.login_container .login_main .select-input-wrapper {
  width: 40.7%;
  position: relative;
}
.login_container .login_main .input-wrapper {
  position: relative;
  width: 85%;
}
.login_container .login_main .input-wrapperpassword {
  position: relative;
  width: 85%;
}
.login_container .login_main input {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 3.4rem;
  margin: 10px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.login_container .login_main .pass-icon {
  position: absolute;
  z-index: 2;
  top: 29px;
  right: 44px;
  display: flex;
  justify-content: end;
  cursor: pointer;
}
.login_container .login_main html[dir=rtl] .pass-icon {
  right: auto !important;
  left: 44px !important;
}
.login_container .login_main .country-label, .login_container .login_main .language-label {
  position: absolute;
  top: 0px;
  z-index: 1;
  left: 28px;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.login_container .login_main label {
  position: absolute;
  top: 0px;
  z-index: 1;
  left: 40px;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.login_container .login_main .required::after {
  content: " *";
  color: red;
}
.login_container .login_main .select-wrapper {
  position: relative;
  display: block;
}
.login_container .login_main .login-select {
  border: 1px solid #a3aec4;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 92% !important;
  height: 3.4rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 1rem;
  color: #10132e;
  cursor: pointer;
}
.login_container .login_main .loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6vh !important;
}
.login_container .login_main .loader-container .loader {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 2s linear infinite;
}

.footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
}

.ErrorMessage {
  display: flex !important;
  color: red;
  padding-right: 50%;
  margin-top: -0.8rem;
  text-align: left !important;
  white-space: nowrap;
  width: 66%;
}

@media screen and (max-width: 1024px) {
  .login_container .loginfirstpara {
    width: 80% !important;
  }
}
@media screen and (max-width: 480px) {
  .login_container .loginfirstpara {
    width: 98% !important;
  }
  .login_container .login_main .input-wrapper {
    width: 95% !important;
  }
  .login_container .login_main .input-wrapperpassword {
    width: 95% !important;
  }
  .loginthirdpara {
    display: flex;
    flex-direction: column;
  }
  .login_container .loginfirstpara {
    width: 98% !important;
  }
  .select-input-wrapper {
    width: 95% !important;
  }
  .login_container .login_main .login-select {
    margin: 10px auto;
    width: 100% !important;
  }
  .login_container .login_main input {
    margin: 10px auto;
    width: 100% !important;
  }
  .login_container .login_main .login-now-buttons {
    width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/LoginComponent/login.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AAEE;EACE,qBAAA;EACA,YAAA;AAAJ;AAGE;EACE,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;AAGI;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AADN;AAII;EACE,iBAAA;AAFN;AAKI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AAHN;AAMI;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAJN;AAMI;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAJN;AAMI;EACE,kBAAA;EACA,UAAA;AAJN;AAOI;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;AALN;AAQI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAQI;EACE,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AANN;AASI;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AAPN;AAUI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARN;AAWI;EACE,UAAA;EACA,iBAAA;EACA,uBAAA;AATN;AAYI;EACE,iBAAA;AAVN;AAaI;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mEAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAXN;AAcI;EACE,iBAAA;EACA,eAAA;AAZN;AAeI;EACE,YAAA;EACA,aAAA;AAbN;AAgBI;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,iBAAA;AAdN;AAiBI;EACE,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAfN;AAkBI;EACE,YAAA;EACA,kBAAA;AAhBN;AAmBI;EACE,kBAAA;EACA,UAAA;AAjBN;AAoBI;EACE,kBAAA;EACA,UAAA;AAlBN;AAqBI;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAnBN;AAsBI;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;AApBN;AAuBI;EACE,sBAAA;EACA,qBAAA;AArBN;AAwBI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAtBN;AAyBI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAvBN;AAyBI;EACE,aAAA;EACA,UAAA;AAvBN;AA0BI;EACE,kBAAA;EACA,cAAA;AAxBN;AA2BI;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAzBN;AA4BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA1BN;AA4BM;EACE,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AA1BR;;AAmCA;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAhCF;;AAmCA;EACE,wBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;AAhCF;;AAmCA;EAEE;IACE,qBAAA;EAjCF;AACF;AAoCA;EACE;IACE,qBAAA;EAlCF;EAqCA;IACE,qBAAA;EAnCF;EAsCA;IACE,qBAAA;EApCF;EAuCA;IACE,aAAA;IACA,sBAAA;EArCF;EAwCA;IACE,qBAAA;EAtCF;EAyCA;IACE,qBAAA;EAvCF;EA0CA;IACE,iBAAA;IACA,sBAAA;EAxCF;EA2CA;IACE,iBAAA;IACA,sBAAA;EAzCF;EA4CA;IACE,UAAA;EA1CF;AACF","sourcesContent":[".login_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: white;\n\n  .tvs_logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin: 40px 0px;\n  }\n\n  .loginfirstpara {\n    width: 50% !important;\n    height: 100%;\n  }\n\n  .login_main {\n    background: #ffffff;\n    box-shadow: 3px 3px 30px rgba(0, 0, 0, 0.12);\n    border-radius: 6px;\n    width: 100%;\n    height: 100%;\n    margin-bottom: 2rem;\n\n    .login_tvsadminfirst {\n      margin: 0rem 0rem;\n      padding: 0rem 0rem;\n      display: flex;\n      gap: 0.4rem;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .login_tvsadminfirst>img {\n      margin: 1rem 0rem;\n    }\n\n    .login_thirdpara {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      width: 100%;\n    }\n\n    .loginthirdpara {\n      width: 85%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n    }\n    .language_input_box{\n      width: 85%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n    }\n    .language_input_wrapper{\n      position: relative;\n      width: 85%;\n    }\n\n    .login_textsecond {\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 19px;\n      letter-spacing: -0.28px;\n      color: #9497a0;\n      display: flex;\n      justify-content: center;\n      margin: 1rem 0rem;\n    }\n\n    .test {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n    .recaptchaContainer{\n      margin: 1rem;\n      width: 85%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      text-align: center;\n    }\n    \n    .Login_text {\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 700;\n      font-size: 20px;\n      line-height: 35px;\n      letter-spacing: -0.28px;\n      color: #10132e;\n    }\n\n    .login_button {\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .login_button>img {\n      width: 75%;\n      object-fit: cover;\n      object-position: bottom;\n    }\n\n    .login-nowslogin-nows {\n      margin: 0rem 1rem;\n    }\n\n    .login-now-buttons {\n      width: 66%;\n      height: 60px;\n      border-radius: 5px;\n      background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n      font-family: \"Poppins\";\n      font-size: 18px;\n      font-weight: 600;\n      color: #ffffff;\n    }\n\n    .loginnows {\n      margin: 0rem 1rem;\n      font-size: 25px;\n    }\n\n    .logininput {\n      width: 700px;\n      height: 605px;\n    }\n\n    .Forget_text {\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 22px;\n      text-align: center;\n      letter-spacing: -0.28px;\n      text-decoration-line: underline;\n      color: #0c3688;\n      margin: 1rem 0rem;\n    }\n\n    .Forgettextdiv {\n      margin: 1rem 0rem 0rem 0rem;\n      padding: 1rem 0rem 1rem 0rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n    }\n\n    .select-input-wrapper{\n      width: 40.7%;\n      position: relative;\n    }\n\n    .input-wrapper {\n      position: relative;\n      width: 85%;\n    }\n\n    .input-wrapperpassword {\n      position: relative;\n      width: 85%;\n    }\n\n    input {\n      border: 1px solid #a3aec4;\n      border-radius: 6px;\n      position: relative;\n      width: 92%;\n      height: 3.4rem;\n      margin: 10px;\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      padding: 0rem 1rem;\n      color: #10132e;\n      cursor: pointer;\n    }\n\n    .pass-icon {\n      position: absolute;\n      z-index: 2;\n      top: 29px;\n      right: 44px;\n      display: flex;\n      justify-content: end;\n      cursor: pointer;\n    }\n\n    html[dir=\"rtl\"] .pass-icon {\n      right: auto !important;\n      left: 44px !important;\n    }\n\n    .country-label, .language-label{\n      position: absolute;\n      top: 0px;\n      z-index: 1;\n      left: 28px;\n      background-color: white;\n      padding: 0 5px;\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      color: #0c3688;\n    }\n\n    label {\n      position: absolute;\n      top: 0px;\n      z-index: 1;\n      left: 40px;\n      background-color: white;\n      padding: 0 5px;\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      color: #0c3688;\n    }\n    .required::after {\n      content: ' *';\n      color: red;\n    }\n\n    .select-wrapper {\n      position: relative;\n      display: block;\n    }\n\n    .login-select {\n      border: 1px solid #a3aec4;\n      border-radius: 6px;\n      position: relative;\n      margin: 10px;\n      line-height: 6ex;\n      width: 92% !important;\n      height: 3.4rem;\n      font-family: \"Nunito\";\n      font-style: normal;\n      font-weight: 600;\n      font-size: 16px;\n      padding: 0rem 1rem;\n      color: #10132e;\n      cursor: pointer;\n    }\n\n    .loader-container {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 6vh !important;\n\n      .loader {\n        border: 3px solid #f3f3f3;\n        border-top: 3px solid #3498db;\n        border-radius: 50%;\n        width: 35px;\n        height: 35px;\n        animation: spin 2s linear infinite;\n      }\n    }\n\n  }\n\n\n}\n\n.footer_div {\n  margin-top: 1rem;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 999;\n}\n\n.ErrorMessage {\n  display: flex !important;\n  color: red;\n  padding-right: 50%;\n  margin-top: -0.8rem;\n  text-align: left !important;\n  white-space: nowrap;\n  width: 66%;\n}\n\n@media screen and (max-width:1024px) {\n\n  .login_container .loginfirstpara {\n    width: 80% !important;\n  }\n}\n\n@media screen and (max-width:480px) {\n  .login_container .loginfirstpara {\n    width: 98% !important;\n  }\n\n  .login_container .login_main .input-wrapper {\n    width: 95% !important;\n  }\n\n  .login_container .login_main .input-wrapperpassword {\n    width: 95% !important;\n  }\n\n  .loginthirdpara{\n    display: flex;\n    flex-direction: column;\n  }\n\n  .login_container .loginfirstpara {\n    width: 98% !important;\n  }\n\n  .select-input-wrapper{\n    width: 95% !important;\n  }\n\n  .login_container .login_main .login-select {\n    margin: 10px auto;\n    width: 100% !important;\n  }\n\n  .login_container .login_main input {\n    margin: 10px auto;\n    width: 100% !important;\n  }\n\n  .login_container .login_main .login-now-buttons {\n    width: 95%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
